let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eTIIn")).then(() => parcelRequire('ackQ5'));